import React from 'react';
import { useTranslation } from 'react-i18next';

import { filterTeamState } from 'store';
import { ConsultationFilterMultiSelect } from 'components';
import { useConsulteeTeams } from 'api';

export const ConsultationTeamFilter: React.FC = () => {
  const { t } = useTranslation('filter');

  const { data: teamData } = useConsulteeTeams();

  return (
    <>
      {teamData?.teams?.length && teamData.teams.length > 1 ? (
        <ConsultationFilterMultiSelect
          label={t('team_title', 'Team')}
          items={teamData?.teams}
          state={filterTeamState}
        />
      ) : null}
    </>
  );
};
